import './styles/main.scss'
import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import router from "./router"

import { auth } from './components/firebase/config.js';
import { onAuthStateChanged } from 'firebase/auth';

let app;

onAuthStateChanged(auth, () => {
  if (!app) {
    app = createApp(App)
          .use(Quasar, quasarUserOptions)
          .use(router)
          .mount('#app');
  }
});
